// listas-20261022: editor de lista de teléfonos (altas/bajas, 10 dígitos MX → se muestra como +52 …)
import { useState } from 'react';
import { toast } from 'sonner';
import { formatPhone10, phone10 } from '../lib/waBlacklistUtils';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';

export const e164 = (d) => (d && d.length === 10 ? `+52 ${formatPhone10(d)}` : d);

export default function PhoneListEditor({ idPrefix, entries, onChange, emptyText, addLabel = 'Agregar', disabled }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);

  const add = async (e) => {
    e.preventDefault();
    const p10 = phone10(phone);
    if (!p10) {
      toast.error('Ingresa un teléfono válido: 10 dígitos o +52…');
      return;
    }
    if (entries.some((x) => x.phone_digits === p10)) {
      toast.error('Ese número ya está en la lista.');
      return;
    }
    setBusy(true);
    try {
      await onChange([...entries, { phone_digits: p10, name: name.trim() }]);
      setName('');
      setPhone('');
      toast.success(`Agregado ${e164(p10)}`);
    } catch {
      toast.error('No se pudo guardar.');
    } finally {
      setBusy(false);
    }
  };

  const remove = async (p10) => {
    try {
      await onChange(entries.filter((x) => x.phone_digits !== p10));
      toast.success('Número quitado.');
    } catch {
      toast.error('No se pudo quitar.');
    }
  };

  return (
    <div className="space-y-4">
      <form onSubmit={add} className="grid gap-3 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
        <div className="space-y-1">
          <Label htmlFor={`${idPrefix}_name`}>Nombre (opcional)</Label>
          <Input id={`${idPrefix}_name`} value={name} maxLength={120} onChange={(e) => setName(e.target.value)}
            placeholder="Ej. Daniel" disabled={disabled} />
        </div>
        <div className="space-y-1">
          <Label htmlFor={`${idPrefix}_phone`}>Teléfono</Label>
          <Input id={`${idPrefix}_phone`} type="tel" value={phone} onChange={(e) => setPhone(e.target.value)}
            placeholder="10 dígitos o +52…" disabled={disabled} />
        </div>
        <Button type="submit" variant="secondary" disabled={busy || disabled}>
          {busy ? 'Guardando…' : addLabel}
        </Button>
      </form>
      {entries.length === 0 ? (
        <p className="text-sm text-muted-foreground">{emptyText}</p>
      ) : (
        <ul className="divide-y divide-border rounded-md border border-border">
          {entries.map((row) => (
            <li key={row.phone_digits} className="flex items-center justify-between gap-3 px-3 py-2">
              <div className="min-w-0">
                <p className="font-mono text-sm text-foreground">{e164(row.phone_digits)}</p>
                {row.name ? <p className="truncate text-xs text-muted-foreground">{row.name}</p> : null}
              </div>
              <Button variant="outline" size="sm" onClick={() => remove(row.phone_digits)} disabled={disabled}>
                Quitar
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
